import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import AppForm from 'components/Form/AppForm/AppForm'
import AppConsent from 'components/Consents/AppConsents/AppConsent'
import { AppState } from 'store'
import useAppFormLogic from 'components/Form/AppForm/hooks/useAppFormLogic'
import { mObywatelExtendedInfoForm } from 'FormDefinitions/MObywatelExtendedInfoForm/MObywatelExtendedInfoFormDefinition'
import { AdditionalApplicationDataProps } from 'components/Form/AppForm/AppFormProps'
import { MObywatelExtendedInfoFieldsNames, mObywatelExtendedInfoFields } from 'FormDefinitions/MObywatelExtendedInfoForm/MObywatelExtendedInfoFields'
import { changeApplicationStep } from 'store/ApplicationSlice/ApplicationSlice'
import { PAGE_STEPER_STAGES } from 'components/Navbar/pageSteps'
import analyticsService from 'service/AnalyticsService/AnalyticsService'


/**
 * Strona formularza zbierająca dodatkowe informacje po identyfikacji użytkownika poprzez mObywatela
*/
const MObywatelExtendedInfoForm = (): JSX.Element => {
   const dispatch = useDispatch()
   const formState = useSelector((state: AppState) => state.formState)
   const consentsState = useSelector((state: AppState) => state.consentsState.appConsents)
   const applicationState = useSelector((state: AppState) => state.applicationState)
   const minimalLoanAmountToDisplayAdditionalFields = useSelector((state: AppState) => state.globalConfigurationState.globalConfig.minimalLoanAmountToDisplayAdditionalFields)
   const analyticsEventTypesNames = useSelector((state: AppState) => state.globalConfigurationState.analyticsEventTypesNames)

   const mObywatelLimitedFieldsNames = [MObywatelExtendedInfoFieldsNames.PhoneNumber, MObywatelExtendedInfoFieldsNames.Email, MObywatelExtendedInfoFieldsNames.ConfirmEmail]

   const additionalApplicationData: AdditionalApplicationDataProps = {
      minimalLoanAmountToDisplayAdditionalFields,
      amountToPay: applicationState.amountToPay,
      billingCompany: applicationState.billingCompany
   }

   const { handleMObywatelExtendedInfoFormSubmitButtonClick, setCurrentFormFields } = useAppFormLogic({ form: mObywatelExtendedInfoForm })
   

   useEffect(() => {
      analyticsEventTypesNames !== undefined && analyticsService.sendAnalyticEvent(analyticsEventTypesNames.MobywatelExtendedInfoFormShow)
      dispatch(changeApplicationStep(PAGE_STEPER_STAGES.SUBMIT_APPLICATION))
   }, [])
   

   return ( 
      <AppForm 
         form={setCurrentFormFields(mObywatelExtendedInfoForm, mObywatelLimitedFieldsNames, mObywatelExtendedInfoFields, additionalApplicationData)} 
         handleSubmitButtonClick={(e: React.SyntheticEvent) => handleMObywatelExtendedInfoFormSubmitButtonClick(e, formState, consentsState, additionalApplicationData)}  
      >
         <AppConsent />
      </AppForm>
   )
}

export default MObywatelExtendedInfoForm